import { initShippingModalFeature } from '../../shippingModal/scripts/setupShippingModal';

window.addEventListener('load', () => {
  const wrapperElement = document.querySelector('.announcement-bar__wrapper');
  if (!wrapperElement) return;

  function mainCarouselFunc() {
    // Get the first announcement bar with custom color
    const announcementBarFirst = wrapperElement.querySelector('.announcement-bar[custom-color]');
    if (announcementBarFirst) {
      const bgColor = announcementBarFirst.dataset.color || '';
      const textColor = announcementBarFirst.dataset.textColor || '';

      // Apply styles
      announcementBarFirst.style.backgroundColor = bgColor;

      // Update text elements
      const textElements = announcementBarFirst.querySelectorAll('.announcement-bar__text, .announcement-bar__arrow');
      textElements.forEach((el) => {
        el.style.color = textColor;
      });
    }

    // Get all visible announcement bars
    const allBars = Array.from(wrapperElement.querySelectorAll('.announcement-bar:not(.hidden)'));
    const messagesCount = allBars.length;

    const interval = (parseInt(wrapperElement.dataset.interval, 10) || 5) * 1000; // Default to 5 seconds if not set
    const transition = wrapperElement.dataset.transitionSpeed || 'standard';
    const isCarousel = wrapperElement.dataset.isCarousel === 'true';

    // Set transition speed based on setting
    let transitionSpeed;
    switch (transition) {
      case 'swift':
        transitionSpeed = 400;
        break;
      case 'standard':
        transitionSpeed = 600;
        break;
      case 'slow':
        transitionSpeed = 1000;
        break;
      default:
        transitionSpeed = 600; // Default to standard if not specified
    }

    // Set initial active class
    const firstBar = allBars[0];
    if (firstBar) firstBar.classList.add('active');

    // Set up the carousel interval if needed
    if (messagesCount > 1 && isCarousel) {
      setInterval(() => carousel(transitionSpeed), interval);
    }

    function carousel(speed) {
      // Set the transition speed in CSS custom property
      document.documentElement.style.setProperty('--transition-speed', `${speed}ms`);

      const active = wrapperElement.querySelector('.announcement-bar.active');
      if (!active) return;

      const bars = Array.from(wrapperElement.querySelectorAll('.announcement-bar'));
      if (bars.length < 2) return;

      const next =
        active.nextElementSibling && active.nextElementSibling.classList.contains('announcement-bar')
          ? active.nextElementSibling
          : wrapperElement.querySelector('.announcement-bar');
      if (!next) return;

      // Set dynamic colors if needed
      if (next.hasAttribute('custom-color')) {
        next.style.setProperty('--announcement-bg-color', next.dataset.color || 'transparent');
        const textElement = next.querySelector('.announcement-bar__text');
        if (textElement) {
          textElement.style.color = next.dataset.textColor || '';
        }
      }

      // Set initial z-index for proper stacking
      next.style.zIndex = '2';

      // Remove active class from current and add to next
      active.classList.remove('active');
      next.classList.add('active');

      // After transition completes, cleanup z-index
      const onTransitionEnd = () => {
        next.style.zIndex = '';
        next.removeEventListener('transitionend', onTransitionEnd);

        // Reset the transition speed to default after animation
        document.documentElement.style.removeProperty('--transition-speed');
      };

      // Add transition end listener
      next.addEventListener('transitionend', onTransitionEnd, { once: true });

      // Fallback in case transitionend doesn't fire
      const fallbackTimeout = setTimeout(() => {
        next.style.zIndex = '';
        next.removeEventListener('transitionend', onTransitionEnd);
        document.documentElement.style.removeProperty('--transition-speed');
      }, speed + 50);

      // Clean up the timeout when transition ends
      next.addEventListener(
        'transitionend',
        () => clearTimeout(fallbackTimeout),
        { once: true },
      );
    }
  }

  function mainCountdown() {
    const shopName = wrapperElement.dataset.shopName || '';
    const timezone = (() => {
      switch (shopName) {
        case 'Organic Basics US':
          return 'America/New_York';
        case 'Organic Basics UK':
          return 'Europe/London';
        case 'Organic Basics EU':
        default:
          return 'Europe/Copenhagen';
      }
    })();

    const now = new Date();
    const currentTime = now.getTime();

    const countdownElements = document.querySelectorAll('.announcement-countdown');

    countdownElements.forEach((currEl) => {
      const currItem = currEl.closest('.announcement-bar');
      itemCountdown(currEl, currItem);
    });

    function parseDateArray(value) {
      if (!value) return null;
      const parts = value.split(',').map((segment) => Number(segment.trim()));
      if (parts.length < 5 || parts.some((part) => Number.isNaN(part))) return null;
      parts[1] -= 1;
      return parts;
    }

    function buildDate(dateParts) {
      const date = new Date(
        dateParts[0],
        dateParts[1],
        dateParts[2],
        dateParts[3],
        dateParts[4],
      );
      return new Date(date.toLocaleString('en-US', { timezone }));
    }

    function updateCountdownValue(element, selector, value) {
      const target = element.querySelector(selector);
      if (target) {
        target.textContent = value;
      }
    }

    function itemCountdown(currEl, currItem) {
      // Set due date
      const dueDateParts = parseDateArray(currEl.dataset.dueDate);
      if (!dueDateParts) return;

      const dueDate = buildDate(dueDateParts);
      const dueEventTime = dueDate.getTime();
      const remTime = dueEventTime - currentTime;

      // Set from date
      const fromDateParts = parseDateArray(currEl.dataset.fromDate);
      if (!fromDateParts) return;
      const fromDate = buildDate(fromDateParts);
      const fromEventTime = fromDate.getTime();

      if (fromEventTime > currentTime) {
        currItem?.remove();
        return;
      }

      if (dueEventTime < currentTime) {
        currItem?.remove();
        return;
      }

      let sec = Math.floor(remTime / 1000);
      let min = Math.floor(sec / 60);
      let hour = Math.floor(min / 60);
      let day = Math.floor(hour / 24);

      hour %= 24;
      min %= 60;
      sec %= 60;

      updateCountdownValue(currEl, '.days', day);
      updateCountdownValue(currEl, '.hours', hour);
      updateCountdownValue(currEl, '.minutes', min);
      updateCountdownValue(currEl, '.seconds', sec);
    }

    setTimeout(mainCountdown, 1000);
  }

  function notShownOnThisPage() {
    wrapperElement.querySelectorAll('.not-shown-on-this-page').forEach((el) => el.remove());
    if (!wrapperElement.children.length) wrapperElement.remove();
  }

  notShownOnThisPage();
  mainCountdown();
  mainCarouselFunc();
  // Second call serves as a callback function once carousel changed DOM
  notShownOnThisPage();

  initShippingModalFeature();
});

class AnnouncementBarWrapper extends HTMLElement {
  constructor() {
    super();
    this.announcementBarMessages = [];
    this.observer = null;
  }

  connectedCallback() {
    this.announcementBarMessages = Array.from(this.querySelectorAll('.announcement-bar__text'));
    if (this.announcementBarMessages.length === 0) return;

    this.equalizeHeights();
    this.observeResize();
  }

  equalizeHeights() {
    let maxHeight = 0;

    // Reset height and measure
    this.announcementBarMessages.forEach(bar => {
      const height = bar.offsetHeight;
      if (height > maxHeight) maxHeight = height;
    });

    this.style.height = `${maxHeight + 8}px`; // Padding
  }

  observeResize() {
    if (typeof ResizeObserver === 'undefined') return;

    this.observer = new ResizeObserver(() => {
      this.equalizeHeights();
    });

    this.announcementBarMessages.forEach(bar => {
      this.observer.observe(bar);
    });
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define('announcement-bar-wrapper', AnnouncementBarWrapper);